var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 92,
    height: 92,
    fill: "#161310"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 80,
    height: 80,
    fill: "#fffaef"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26,
    width: 68,
    height: 68,
    fill: "#f2ead6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 34,
    width: 28,
    height: 8,
    fill: "#31553f"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 42,
    width: 44,
    height: 8,
    fill: "#31553f"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 50,
    width: 28,
    height: 8,
    fill: "#31553f"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 58,
    width: 8,
    height: 8,
    fill: "#31553f"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 66,
    width: 36,
    height: 8,
    fill: "#31553f"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 58,
    width: 8,
    height: 8,
    fill: "#31553f"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 42,
    width: 8,
    height: 8,
    fill: "#6f9b56"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 58,
    width: 8,
    height: 8,
    fill: "#6f9b56"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 34,
    width: 28,
    height: 8,
    fill: "#31553f"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 42,
    width: 8,
    height: 24,
    fill: "#31553f"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 66,
    width: 28,
    height: 8,
    fill: "#31553f"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 50,
    width: 8,
    height: 16,
    fill: "#31553f"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 50,
    width: 20,
    height: 8,
    fill: "#31553f"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 42,
    width: 8,
    height: 8,
    fill: "#6f9b56"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 58,
    width: 8,
    height: 8,
    fill: "#6f9b56"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 66,
    width: 8,
    height: 14,
    fill: "#7a4a2a"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 58,
    width: 8,
    height: 22,
    fill: "#7a4a2a"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 66,
    width: 8,
    height: 14,
    fill: "#7a4a2a"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 74,
    width: 8,
    height: 8,
    fill: "#7a4a2a"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 74,
    width: 8,
    height: 8,
    fill: "#7a4a2a"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 80,
    width: 56,
    height: 8,
    fill: "#161310"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 88,
    width: 48,
    height: 12,
    fill: "#d85b49"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 100,
    width: 32,
    height: 6,
    fill: "#161310"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 88,
    width: 8,
    height: 8,
    fill: "#f2ead6"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 88,
    width: 8,
    height: 8,
    fill: "#f2ead6"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 108,
    width: 88,
    height: 6,
    fill: "#161310",
    opacity: 0.35
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4aa1e60485aa807004548852126a3fe2.svg";
export { ForwardRef as ReactComponent };